import { useRef } from 'react';

// =================================================================

interface ScrollToProps {
  top?: number;
  left?: number;
  behavior: 'auto' | 'smooth';
}

interface ScrollToElement extends Partial<Pick<ScrollToProps, 'behavior'>> {
  offset: number;
}

// =================================================================

const scrollTo = (options: ScrollToProps) => {
  const {
    top = document.documentElement.scrollTop,
    left = document.documentElement.scrollLeft,
    behavior,
  } = options;

  if (window.scrollTo) {
    window.scrollTo({ top, left, behavior });
  } else {
    document.documentElement.scrollTop = top;
    document.documentElement.scrollLeft = left;
  }
};

// =================================================================

export const useScrollToElement = (options: ScrollToElement) => {
  const { offset = 0, behavior = 'smooth' } = options;
  const ref = useRef<HTMLElement>(null);

  const scrollToElement = () => {
    const element = ref.current;

    if (element) {
      const { offsetTop } = element;
      const { scrollTop } = document.documentElement;
      const shouldScrollIntoView = offsetTop - scrollTop - 70 < 0;

      if (shouldScrollIntoView) {
        const { top } = element.getBoundingClientRect();
        scrollTo({ top: top + scrollTop - offset, behavior });
      }
    }
  };

  return { ref, scrollToElement };
};
